/**
 * When this tab last completed a sign-in callback, on the device's own clock, kept in this
 * tab's `sessionStorage`. It is written by the login library's `onSigninCallback`
 * ({@link onSigninCallbackStamp}), which runs only after the authorization response carried
 * by THIS load was exchanged for a user, so it cannot fire for a stored session that is
 * merely loaded again, such as a direct visit to `/callback`. It exists for the snapshot
 * form's load-time rule (`intake/staleLoad.ts`), which reads it as one date among several: a
 * fast device clock makes the server's `auth_time` look old, and this does not. Nothing here
 * grants anything.
 */
const KEY = 'steward-app:signedInAt';

export function recordSignedIn(nowMs: number = Date.now()): void {
  try {
    sessionStorage.setItem(KEY, String(nowMs));
  } catch {
    // storage unavailable: the other readings still date the session
  }
}

export function readSignedInStamp(): number | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (raw === null) return null;
    const v = Number(raw);
    return Number.isFinite(v) && v > 0 ? v : null;
  } catch {
    return null;
  }
}

/** The login library's `onSigninCallback`: stamp only when the callback produced a user. */
export function onSigninCallbackStamp(user: unknown): void {
  if (user) recordSignedIn();
}
